import { Attributes, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class CashReconciliationReportCriteria extends ValueObject {
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";

    public rawAccountId: string | null = null;

    public maxTolerance: number | null = null;

    public minTolerance: number | null = null;

    @Rules.Required()
    @Attributes.Date()
    public holdingsDate: Date | null = new Date();

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
     }
}